module.exports = __webpack_public_path__ + "img/back-img2.56cabebc.png";